import BadgeNext from "ds/components/BadgeNext";
import { BadgeVariants } from "ds/components/BadgeNext/types";
import { WorkerStatus } from "types/generated";

type WorkerStatusConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const WORKER_STATUSES: Record<WorkerStatus, WorkerStatusConfig> = {
  [WorkerStatus.Busy]: { variant: "green", text: "Busy" },
  [WorkerStatus.Drained]: { variant: "red", text: "Drained" },
  [WorkerStatus.Idle]: { variant: "blue", text: "Idle" },
};

type WorkerStatusBadgeProps = {
  status: WorkerStatus;
  className?: string;
};

const WorkerStatusBadge = ({ status, className }: WorkerStatusBadgeProps) => {
  return (
    <BadgeNext
      variant={WORKER_STATUSES[status].variant}
      type="strong"
      className={className}
      text={WORKER_STATUSES[status].text}
    />
  );
};

export default WorkerStatusBadge;
